// extracted by mini-css-extract-plugin
export default {"sideMenuContainer":"SideMenu_sideMenuContainer__eq6jN"};